import { gql } from 'apollo-angular';

export const RemoveBenchmarkFromActivityDocument =
  gql(/* GraphQL*/ `mutation removeBenchmarkFromActivity($benchmarkId: Int!, $activityId: Int!) {
  removeBenchmarkFromActivity(benchmarkId: $benchmarkId, activityId: $activityId)
}
`);
